import api, {
    MutationRequestOptions,
    getMutationRequestConfig,
} from '../utils/axiosConfig'
import { UserResponse, UpdateProfileRequest } from '../types/user'

// 更新当前用户资料（使用 /users/me 而不是 /users/{id}）
export const updateUserProfile = async (
    _userId: string,
    data: UpdateProfileRequest,
    options?: MutationRequestOptions
): Promise<UserResponse> => {
    // 忽略 userId 参数，始终使用 /users/me 更新当前用户
    const response = await api.patch<UserResponse>(
        '/users/me',
        data,
        getMutationRequestConfig(options)
    )
    return response.data
}

// 获取所有用户（管理员）
export const getAllUsers = async (): Promise<UserResponse[]> => {
    const response = await api.get<UserResponse[]>('/users')
    return response.data
}

// 删除用户（管理员）
export const deleteUser = async (
    userId: string,
    options?: MutationRequestOptions
): Promise<void> => {
    await api.delete(`/users/${userId}`, getMutationRequestConfig(options))
}
